import React, { useState, useEffect } from "react";
import { checkResult, createFilePath } from "@/common";
import { useWatchState } from "@/store";
import { BaseService } from "@/service";
import BraftEditor from "braft-editor";
import { Industrial, Business, Height, Attribute, Achievement, Shape, Scale, Expect, Difficulty, Degree, Strength, Trl1_9, Leader_education, Leader_title, Team_person, Team_intermediate, Team_experience } from "../projectRec/projectFunction"
import { Modal, Descriptions, Divider, Button, Icon, Collapse } from "antd";
import moment from "moment";

const { Panel } = Collapse;

function callback(key) {
    console.log(key);
}

const NAME = "projectRec";

const App = () => {
    const [[IS_REGION], [{ IS_LOGIN, info }]] = useWatchState(["IS_REGION", "user",]);
    const [[UPLOAD_SERVER_HOST = ""]] = useWatchState(["$_UPLOAD_SERVER_HOST"]);
    const [[modalProps, setProps]] = useWatchState(["modal." + NAME]);
    const { title = "", show, hide, width = 800, DetailId } = modalProps;
    const [items, setItems] = useState([]);
    const [scopeName, setScopeName] = useState([]);
    const [data, setData] = useState([]);
    const [profile, setProfile] = useState('');

    useEffect(() => {
        if (DetailId) getRecRecord(DetailId)
    }, [DetailId])

    const scope_Name = async (scopeId) => {
        const res = await BaseService.list({
            table: "thtt_scope",
            columns: "name",
            where: {
                "id": scopeId,
                "is_delete": 0,
            },
        })
        if (!checkResult(res)) return;
        setScopeName(res.data.result[0].name);
    }

    const getRecRecord = project_id => {
        BaseService.list({
            table: "thtt_project",
            leftJoin: {
                table: "thtt_user",
                on: "thtt_project.declarant_user_id=thtt_user.user_id",
                columns: ["name AS submit_name,account AS submit_account"],
            },
            where: {
                id: project_id,
                "thtt_project.is_delete": 0,
            },
            process: {
                name: "files",
                key: "id",
                targetKey: "item_id",
                params: {
                    table: "thtt_attachment_relation",
                },
            },
        }).then(res => {
            if (!checkResult(res)) return;
            const data = res.data.result[0];
            const profile = BraftEditor.createEditorState(data.profile);
            scope_Name(data.scope);
            setProfile(profile);
            setData(data);
        })
    }

    const [files, setFiles] = useState([]);
    useEffect(() => {
        if (DetailId) {
            BaseService.list({
                table: "thtt_attachment_relation",
                columns: "id,file_name,file_path",
                where: {
                    item_id: DetailId,
                    is_delete: 0,
                },
            }).then((res) => {
                if (!checkResult(res)) return;
                const files = res.data.result;
                setFiles(files);
            });
        } else setFiles({});
    }, [DetailId]);


    const viewRec = async (DetailId) => {
        const res = await BaseService.list({
            table: "thtt_project_rec_opinion",
            leftJoin: {
                table: "thtt_project_recommend",
                on: "thtt_project_recommend.id=thtt_project_rec_opinion.roc_org",
                columns: ["org_name AS roc_org_name"],
            },
            where: {
                "thtt_project_rec_opinion.project_id": DetailId,
                "thtt_project_rec_opinion.is_delete": 0,
            },
        }).then(res => {
            if (!checkResult(res)) return;
            setItems(res.data.result);
        })
    }

    useEffect(() => {
        if (DetailId) {
            viewRec(DetailId);
        }
    }, [DetailId])


    return (
        <Modal
            visible={show}
            width={width}
            maskClosable={false}
            destroyOnClose
            onCancel={hide}
            footer={false}
        >
            <Collapse defaultActiveKey={[(data.recommend_state === 2) ? '2' : ((data.recommend_state === 1) ? '0' : ((data.recommend_state === 0) ? '3' : '1'))]} onChange={callback}>
                {(data.recommend_state === 1) &&
                    <Panel header="预览项目推荐意见" key="0">
                        {items.map((item) => (
                            <div>
                                <Divider>高技术价值</Divider>
                                <Descriptions layout="vertical" bordered>
                                    <Descriptions.Item label="自主原创重大技术成果">{(item.original === 1) ? '符合' : ((item.original === 2) ? '一般' : '该项未选择')}</Descriptions.Item>
                                    <Descriptions.Item label="前沿引领创新技术成果">{(item.innovate === 1) ? '符合' :  ((item.innovate === 2) ? '一般' : '该项未选择')}</Descriptions.Item>
                                    <Descriptions.Item label="产业关键核心技术成果">{(item.core === 1) ? '符合' : ((item.core === 2) ? '一般' : '该项未选择')}</Descriptions.Item>
                                </Descriptions>
                                <Divider>高产业价值</Divider>
                                <Descriptions layout="vertical" bordered>
                                    <Descriptions.Item label="助力传统产业转型升级">{(item.tradition === 1) ? '符合' :  ((item.tradition === 2) ? '一般' : '该项未选择')}</Descriptions.Item>
                                    <Descriptions.Item label="支撑战略新兴产业发展">{(item.develop === 1) ? '符合' :  ((item.develop === 2) ? '一般' : '该项未选择')}</Descriptions.Item>
                                    <Descriptions.Item label="发挥未来产业定位方向">{(item.strategy === 1) ? '符合' :  ((item.strategy === 2) ? '一般' : '该项未选择')}</Descriptions.Item>
                                </Descriptions>
                                <Divider>高经济价值</Divider>
                                <Descriptions layout="vertical" bordered>
                                    <Descriptions.Item label="项目已实现营收规模大">{(item.realize === 1) ? '符合' : ((item.realize === 2) ? '一般' : '该项未选择')}</Descriptions.Item>
                                    <Descriptions.Item label="项目对地区经济贡献大">{(item.market === 1) ? '符合' :  ((item.market === 2) ? '一般' : '该项未选择')}</Descriptions.Item>
                                    <Descriptions.Item label="项目可实现效益预期大">{(item.profit === 1) ? '符合' : ((item.profit === 2) ? '一般' : '该项未选择')}</Descriptions.Item>
                                </Descriptions>
                                <Divider>高市场价值</Divider>
                                <Descriptions layout="vertical" bordered>
                                    <Descriptions.Item label="成果目标市场规模巨大">{(item.target_market === 1) ? '符合' :  ((item.target_market === 2) ? '一般' : '该项未选择')}</Descriptions.Item>
                                    <Descriptions.Item label="成果推广应用场景多元">{(item.promote === 1) ? '符合' :  ((item.promote === 2) ? '一般' : '该项未选择')}</Descriptions.Item>
                                    <Descriptions.Item label="成果市场生命周期可见">{(item.life_cycle === 1) ? '符合' :  ((item.life_cycle === 2) ? '一般' : '该项未选择')}</Descriptions.Item>
                                </Descriptions>
                                <Divider>高资本价值</Divider>
                                <Descriptions layout="vertical" bordered>
                                    <Descriptions.Item label="项目方向投资热度较高">{(item.investment_heat === 1) ? '符合' :  ((item.investment_heat === 2) ? '一般' : '该项未选择')}</Descriptions.Item>
                                    <Descriptions.Item label="项目团队运作能力较强">{(item.team_operations === 1) ? '符合' :  ((item.team_operations === 2) ? '一般' : '该项未选择')}</Descriptions.Item>
                                    <Descriptions.Item label="项目实施风险防控可信">{(item.implementation_risk === 1) ? '符合' :  ((item.implementation_risk === 2) ? '一般' : '该项未选择')}</Descriptions.Item>
                                </Descriptions>
                                <Divider>高转化价值</Divider>
                                <Descriptions layout="vertical" bordered>
                                    <Descriptions.Item label="主体企业创新能力到位">{(item.generality === 1) ? '符合' :  ((item.generality === 2) ? '一般' : '该项未选择')}</Descriptions.Item>
                                    <Descriptions.Item label="成果转化资源要素到位">{(item.resources === 1) ? '符合' :  ((item.resources === 2) ? '一般' : '该项未选择')}</Descriptions.Item>
                                    <Descriptions.Item label="成果转化落地进程到位">{(item.prepare === 1) ? '符合' :  ((item.prepare === 2) ? '一般' : '该项未选择')}</Descriptions.Item>
                                </Descriptions>
                                <Divider>项目简要评语</Divider>
                                <Descriptions layout="vertical" bordered>
                                    <Descriptions.Item label="项目简要评语:" span={3}>{item.comment}</Descriptions.Item>
                                    <Descriptions.Item label="项目推荐意见" span={1}>{
                                        (item.recommend_type === 1) ? "领航项目" : ((item.recommend_type === 2) ? "启航项目" : "备航项目")
                                    }</Descriptions.Item>
                                    <Descriptions.Item label="推荐时间：" span={1}>{moment(parseInt(item.add_date) * 1000).format("YYYY-MM-DD")}</Descriptions.Item>
                                    <Descriptions.Item label="推荐单位/推荐个人：" span={1}>{item.roc_org_name}</Descriptions.Item>
                                </Descriptions>
                            </div>
                        ))}
                    </Panel>}
                {(data.recommend_state === 2) &&
                    <Panel header="项目推荐意见" key="2">
                        感谢您申报的项目，由于名额为限，本次暂不推荐，我们将在合适的机会推广您的项目。
                    </Panel>}
                {(data.recommend_state === 0) &&
                    <Panel header="项目推荐意见" key="3">
                        感谢您的提交，您的项目已被选为入围项目。
                    </Panel>}
                <Panel header="预览申报项目信息登记表" key="1">
                    <div style={{ textAlign: "center" }}>
                        <h2>科技成果转化项目双推双促工程</h2>
                        <h2>《申报项目信息登记表》</h2>
                    </div>
                    <Divider>申报单位信息</Divider>
                    <Descriptions bordered>
                        <Descriptions.Item label="申报单位名称:" span={3}>{data.org_name}</Descriptions.Item>
                        <Descriptions.Item label="单位所在省/市:" span={2}>{data.org_province_name}</Descriptions.Item>
                        <Descriptions.Item label="单位成立时间:">{(data.establish_date!=='null')?data.establish_date:''}</Descriptions.Item>
                        <Descriptions.Item label="单位产业属性:" span={2}>{Industrial(data.industrial)}</Descriptions.Item>
                        <Descriptions.Item label="单位业务属性:" >{Business(data.business)}</Descriptions.Item>
                        <Descriptions.Item label="单位从业人数（人）:" span={2}>{data.org_person}</Descriptions.Item>
                        <Descriptions.Item label="单位负责人姓名:" >{data.org_leader}</Descriptions.Item>
                        <Descriptions.Item label="项目申报人:" span={2}>{data.submit_name}</Descriptions.Item>
                        <Descriptions.Item label="申报人联系方式:" >{data.submit_account}</Descriptions.Item>
                    </Descriptions>
                    <Divider>申报项目信息</Divider>
                    <Descriptions layout="vertical" bordered >
                        <Descriptions.Item label="申报项目名称:" span={3}>{data.name}</Descriptions.Item>
                        <Descriptions.Item label="项目所属领域:" span={3}>{scopeName}</Descriptions.Item>
                        <Descriptions.Item label="项目内容简介:" span={3}><div dangerouslySetInnerHTML={{ __html: data.profile }}></div></Descriptions.Item>
                    </Descriptions>
                    <Divider>技术创新亮点</Divider>
                    <Descriptions layout="vertical" bordered>
                        <Descriptions.Item label="技术创新高度">{Height(data.height)}</Descriptions.Item>
                        <Descriptions.Item label="技术创新属性">{Attribute(data.attribute)}</Descriptions.Item>
                        <Descriptions.Item label="技术创新成果">{Achievement(data.achievement)}</Descriptions.Item>
                    </Descriptions>
                    <Divider>市场价值要点</Divider>
                    <Descriptions layout="vertical" bordered>
                        <Descriptions.Item label="核心产品市场形态">{Shape(data.shape)}</Descriptions.Item>
                        <Descriptions.Item label="项目已实现市场规模">{Scale(data.scale)}</Descriptions.Item>
                        <Descriptions.Item label="项目未来市场预期">{Expect(data.expect)}</Descriptions.Item>
                    </Descriptions>
                    <Divider>转化要素难点</Divider>
                    <Descriptions layout="vertical" bordered>
                        <Descriptions.Item label="转化所需资源难度">{Difficulty(data.difficulty)}</Descriptions.Item>
                        <Descriptions.Item label="转化资源到位程度">{Degree(data.degree)}</Descriptions.Item>
                        <Descriptions.Item label="转化项目投资力度">{Strength(data.strength)}</Descriptions.Item>
                    </Descriptions>
                    <Divider>转化项目已实现进程</Divider>
                    <Descriptions layout="vertical" bordered>
                        <Descriptions.Item label="TRL1-9">{Trl1_9(data.trl1_9)}
                        </Descriptions.Item>
                    </Descriptions>
                    <Divider>项目研发负责人</Divider>
                    <Descriptions bordered>
                        <Descriptions.Item label="姓名">{data.leader_name}</Descriptions.Item>
                        <Descriptions.Item label="学历">{Leader_education(data.leader_education)}</Descriptions.Item>
                        <Descriptions.Item label="职称">{Leader_title(data.leader_title)}</Descriptions.Item>
                    </Descriptions>
                    <Divider>项目研发团队</Divider>
                    <Descriptions layout="vertical" bordered>
                        <Descriptions.Item label="团队人数">{Team_person(data.team_person)}</Descriptions.Item>
                        <Descriptions.Item label="中级以上人员占比">{Team_intermediate(data.team_intermediate)}</Descriptions.Item>
                        <Descriptions.Item label="团队合作经验">{Team_experience(data.team_experience)}</Descriptions.Item>
                    </Descriptions>
                    <p>
                        <span className="bold dark-title">附件：</span> {Array.isArray(files) ? files.map((item) => {
                            return (
                                <li>
                                    <a href={createFilePath(item.file_path, UPLOAD_SERVER_HOST)} className="blue" target="_black">
                                        <Icon type="link" /> {item.file_name}
                                    </a></li>)
                        })
                            : null}
                    </p>
                    <p style={{ textAlign: "center" }}>
                        <Button type="primary" onClick={hide}>关闭</Button>
                    </p>
                </Panel>
            </Collapse>
        </Modal>
    );
}

export default App;